import { BaseFilterOption, UniversalFiltersData } from "web/types/universal-filters";

export class PendingFilters extends Map<string, boolean> {
    public getKey(name: string, value: string): string {
        return name + "=" + value;
    }

    public getChecked(filter: BaseFilterOption): boolean {
        let value = this.get(this.getKey(filter.name, filter.value.toString()));

        if (value == null) {
            return filter.checked;
        }

        return value;
    }

    public setChecked(name: string, value: string, state: boolean): void {
        let key = this.getKey(name, value);
        let existing = this.get(key);
        if (existing == null) {
            this.set(key, state);
            return;
        } else if (state == existing) {
            return;
        }
        // If the user selects something and then unselects it, we don't want to
        // keep it in the pending object to reduce the complexity of updating
        // our query to the server.
        this.delete(key);
    }

    public hasPending(): boolean {
        return this.size > 0;
    }

    public toQuery(displayedFilters: UniversalFiltersData): URLSearchParams {
        // This is the query for the current menu state of filters that we send to
        //  Rothko for an updated filter set and for updating feeds.
        let filterQuery = new URLSearchParams(displayedFilters.query_string);

        for (let [pendingKey, pendingChecked] of this.entries()) {
            let [pendingName, pendingValue] = pendingKey.split("=");
            if (pendingChecked) {
                filterQuery.append(pendingName, pendingValue);
            } else {
                filterQuery.deleteValue(pendingName, pendingValue);
            }
        }
        return filterQuery;
    }
}
